let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("as5U5")).then(() => parcelRequire('lmcDN'));